<template>
    <div>
        <v-row>
            <v-col cols="6">
                <view-card :headline="'신청정보'">
                    <v-row>
                        <view-card-column>
                            <view-card-row :heading="'시공지 유형'" :sm="12" :mt="false">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.category.parents[0].name + "/" + inquiry.category.name }}</v-col>
                            </view-card-row>
                            <view-card-row :heading="'시공 면적'" :sm="12">
                                <v-col class="py-0 text-subtitle-1">{{ Number(inquiry.acreage || 0).format() + "평" }}</v-col>
                            </view-card-row>
                        </view-card-column>
                        <view-card-column>
                            <view-card-row :heading="'시공 희망일'" :sm="12" :mt="false">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.targetDate }}</v-col>
                            </view-card-row>
                            <view-card-row :heading="'시공 예산'" :sm="12">
                                <v-col class="py-0 text-subtitle-1">{{ budget }}</v-col>
                            </view-card-row>
                        </view-card-column>
                    </v-row>
                    <view-card-row :heading="'주소'" :sm="12">
                        <v-col class="py-0 text-subtitle-1">({{ inquiry.postcode }}) {{ inquiry.address1 }}, {{ inquiry.address2 }}</v-col>
                    </view-card-row>
                </view-card>
                <view-card v-if="!isInterior" :headline="'신청자정보'">
                    <v-row>
                        <view-card-column>
                            <view-card-row :heading="'성함'" :sm="12" :mt="false">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.name }}</v-col>
                            </view-card-row>
                        </view-card-column>
                        <view-card-column>
                            <view-card-row :heading="'연락처'" :sm="12" :mt="false">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.phone.phoneNumberFormat() }}</v-col>
                            </view-card-row>
                        </view-card-column>
                    </v-row>
                </view-card>
                <view-card v-if="!isInterior && hasUser" :headline="'사용자정보'">
                    <v-row>
                        <view-card-column>
                            <view-card-row :heading="'성함'" :sm="12" :mt="false">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.user.name }}</v-col>
                            </view-card-row>
                            <view-card-row :heading="'이메일'" :sm="12">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.user.email }}</v-col>
                            </view-card-row>
                        </view-card-column>
                        <view-card-column>
                            <view-card-row :heading="'연락처'" :sm="12" :mt="false">
                                <v-col class="py-0 text-subtitle-1">{{ inquiry.user.phone.phoneNumberFormat() }}</v-col>
                            </view-card-row>
                        </view-card-column>
                    </v-row>
                </view-card>
            </v-col>
            <v-col cols="6">
                <view-card :headline="'신청정보상세'">
                    <view-card-row :heading="'요청사항'" :sm="12" :mt="false">
                        <v-col class="pb-0 text-subtitle-1" style="line-height:1.5;white-space:pre-wrap;">{{ inquiry.requests }}</v-col>
                    </view-card-row>
                    <infos-portfolio v-if="hasPortfolio" :portfolio="inquiry.portfolio" @show-overlay="showOverlay" />
                    <view-card-row v-else heading="선택한 스타일" :sm="12">
                        <v-col @click="showOverlay(inquiry.image)" cols="12" sm="12" class="py-0 d-flex justify-center align-center" style="cursor:pointer;">
                            <v-img max-width="100%" max-height="100%" v-if="inquiry.image" :src="inquiry.image" />
                        </v-col>
                    </view-card-row>
                </view-card>
            </v-col>
        </v-row>
        <view-overlay :overlay="overlay" @hide-overlay="hideOverlay"></view-overlay>
    </div>
</template>
<script>
import ViewCardColumn from "../dumb/view-card-column.vue";
import ViewCardRow from "../dumb/view-card-row.vue";
import viewCard from "../dumb/view-card.vue";
import ViewOverlay from "../dumb/view-overlay.vue";
import InfosPortfolio from "./infos-portfolio.vue";
export default {
    components: { viewCard, ViewCardColumn, ViewCardRow, InfosPortfolio, ViewOverlay },
    props: { inquiry: Object },
    data() {
        return {
            overlay: {
                show: false,
                src: undefined,
            },
        };
    },
    methods: {
        showOverlay(src) {
            this.overlay = { show: true, src };
        },
        hideOverlay() {
            this.overlay = { show: false, src: undefined };
        },
    },
    computed: {
        budget() {
            let target = this.inquiry?.budget;
            if (target) {
                if (target.includes("원") || target.includes("미정")) return target;
                else {
                    target = Number(target);
                    if (target > 10000) {
                        return (target / 10000).format() + "억" + (target % 10000 ? `${(target % 10000).format()}만원` : "");
                    } else return (target % 10000).format() + "만원";
                }
            } else return "-";
        },

        hasUser() {
            return this.inquiry?._user ? true : false;
        },
        hasPortfolio() {
            return this.inquiry?._portfolio ? true : false;
        },
        isInterior() {
            return this.scope.includes("interior");
        },

        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        _user() {
            return this.payload._user;
        },
    },
};
</script>
